<script setup>

  const props = defineProps({
    ann: {
      type: Object,
      required: true
    }
  })

  import { VideoStore } from '@/front/stores/video_store.js';
  const videoStore = VideoStore();

  const customStyle = props.ann.customStyle && JSON.parse(props.ann.customStyle) || {}

  const baseDesign = videoStore.video.design || {}
  const circleStyle = computed(() => {
    return {
      'backgroundColor': props.ann.background_color || customStyle.background_color || baseDesign.color,
      'width': '50px',
      'height': '50px',
      'backgroundImage': props.ann.background_image ? `url('${props.ann.background_image}')` : 'none',
      'backgroundSize': 'contain',
      'backgroundPosition': 'center',
      'backgroundRepeat': 'no-repeat',
    }
  })
  const ringStyle = computed(() => {
  
    return {
      'borderColor': props.ann.background_color || customStyle.background_color || baseDesign.color,
      'borderWidth': '4px',
      'min-width': '50px',
      'min-height': '50px',
    }
  })
</script>

<template>
  <div>
    <div class="flex items-center justify-center min-h-[60px]">
      <!-- <span class="spot-ring" :style="ringStyle"></span> -->
      <span class="spot-circle" :style="circleStyle"></span>
    </div>
    <div v-if="ann.caption || ann.extra || ann.internal_label" class="text-sm mt-2">
      <div v-if="ann.caption">{{ ann.caption }}</div>
      <div v-else-if="ann.extra">{{ ann.extra }}</div>
      <div v-else-if="ann.internal_label">{{ ann.internal_label }}</div>
    </div>
  </div>

</template>